export default {
  LOADING_STATES: 'ADMIN_VIEW_MARKET_DELETOR_LOADING_STATES',
  LOADED_STATES: 'ADMIN_VIEW_MARKET_DELETOR_LOADED_STATES',
  DELETING: 'ADMIN_VIEW_MARKET_DELETOR_DELETING',
  DELETED: 'ADMIN_VIEW_MARKET_DELETOR_DELETED',
};
